import * as types from '../actionTypes/ActionTypes';

const filterVoucher = {
  currentSort: 1,
  pageNumber: 1,
  pageSize: 50,
  sortBy: 'Voucher.Date',
  sortType: 'desc',
  isLoading: false,
  keyword: '',
  status: 0,
  connectStatus: '',
};

const initialState = {
  filterVoucher,
  transactions: null,
  vouchers: {
    rows: [],
    total: 0,
  },
  loading: {
    voucher: false,
    transaction: false,
  },
};

const connectMissing = (state = initialState, action) => {
  switch (action.type) {
    case types.CONNECT_MISSING.SET_CONNECT_MISSING_FILTER_VOUCHER:
      return {
        ...state,
        filterVoucher: action.payload,
      };
    case types.CONNECT_MISSING.SET_CONNECT_MISSING_BANK:
      return {
        ...state,
        transactions: action.payload,
      };
    case types.CONNECT_MISSING.SET_CONNECT_MISSING_VOUCHER:
      return {
        ...state,
        vouchers: action.payload,
      };
    case types.CONNECT_MISSING.GET_CONNECT_MISSING_VOUCHER_REQUEST:
      return {
        ...state,
        loading: {
          voucher: true,
        },
      };
    case types.CONNECT_MISSING.GET_CONNECT_MISSING_VOUCHER_SUCCESS:
      return {
        ...state,
        vouchers: action.payload,
        loading: {
          voucher: false,
        },
      };
    case types.CONNECT_MISSING.REMOVE_RECORD_VOUCHER:
      const newRow = state.vouchers.rows.filter((v) => v.Id !== +action.payload);
      const newTotal = state.vouchers.total - 1;
      return {
        ...state,
        vouchers: {
          rows: newRow,
          total: newTotal,
        },
        loading: {
          voucher: false,
        },
      };
    case types.CONNECT_MISSING.GET_CONNECT_MISSING_VOUCHER_FAIL:
      return {
        ...state,
        loading: {
          voucher: false,
        },
      };
    default:
      return state;
  }
};

export default connectMissing;
